import { brandParentIds } from "./constants";

const isBrand = ({ breadcrumbs }) => {
  const { CategoryId: parentCategoryId } = breadcrumbs[breadcrumbs.length - 2];

  return brandParentIds.some(id => id === parentCategoryId);
};

export default isBrand;
